module.exports = __webpack_public_path__ + "img/symbol_18.948b5831.png";